"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Disclaimer_1 = __importDefault(require("./Disclaimer"));

exports.default = Disclaimer_1.default;